module.exports = __webpack_public_path__ + "static/img/pop_bg.ff1fb83.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/common/pop_bg.png
// module id = B1FU
// module chunks = 2